module.exports = __webpack_public_path__ + "img/ep2-4.93f586a1.png";